import { gql } from '@apollo/client';

export const BANK_PARSER_RULE_UPSERT = gql`
  mutation BankParserRuleUpsert($value: BankParserRuleUpsertInput!) {
    BankParserRuleUpsert(value: $value) {
      success
      message
      data {
        bankId
        bankPrefix
        bankCode
        bankNameEN
        bankNameTH
        bankImage
        ruleId
        bankExtractor
        receiveExtractor
        accountRegex
        accountFormatSample
        amountRegex
        dateRegex
        sampleText
        priority
        status
        hasCustomRule
      }
    }
  }
`;

